// Tiny pure helper for the inline field-error summary banner on the
// customer rental application form (SubmissionFormPage). Extracted only
// so the singular/plural grammar is unit-testable without spinning up
// the whole page.
//
// Example:
//   formatErrorSummaryLabel(0) → "0 fields need attention"
//   formatErrorSummaryLabel(1) → "1 field needs attention"
//   formatErrorSummaryLabel(2) → "2 fields need attention"
//
// We intentionally include the count in the returned string so callers
// can drop it straight into a banner without re-templating.
export function formatErrorSummaryLabel(count) {
    const n = Number.isFinite(count) ? Math.max(0, Math.floor(count)) : 0;
    if (n === 1) return "1 field needs attention";
    return `${n} fields need attention`;
}

// Secondary sub-line for the banner — "{N} saved, {M} failed".
// Driven off the partial-save 400 response's `saved_keys` array (each
// element is a field key that was valid and persisted on that same
// PATCH). Returns null when `saved_keys` is absent / not an array so
// the banner can gracefully omit the sub-line for older or malformed
// payloads — never render "undefined saved" or "NaN saved".
//
// `failedCount` is taken from the page's current fieldErrors size so
// the sub-line stays in sync with the primary "N fields need attention"
// line as the customer corrects individual fields. Zero is intentionally
// rendered as the literal "0" — it's a useful signal ("0 saved, 2
// failed" tells the customer nothing was persisted on that attempt).
export function formatSavedFailedSubline(savedKeys, failedCount) {
    if (!Array.isArray(savedKeys)) return null;
    const saved = savedKeys.length;
    const failed = Number.isFinite(failedCount)
        ? Math.max(0, Math.floor(failedCount))
        : 0;
    return `${saved} saved, ${failed} failed`;
}
